"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetArticles = void 0;
var _react = require("react");
var _constants = require("./constants");
var _getCountOfPages = require("./getCountOfPages");
var _parseArticles = require("./parseArticles");
/**
 * Hook accepts articles loaded from GraphQL and parses them through `parseArticles`. Decides page count based on `getCountOfPages`.
 * Returns parsed articles pages (`articles`), `countOfPages`, info about possible articles fetching (`loadingArticles`)
 * and callback to load another page of articles (`loadMore`).
 */ const useGetArticles = (param)=>{
    let { articles: initialArticles, countOfArticles = 0, pageSize = _constants.DEFAULT_PAGE_SIZE } = param;
    const articles = (0, _parseArticles.parseArticles)({
        articles: initialArticles
    });
    const countOfPages = (0, _getCountOfPages.getCountOfPages)({
        countOfArticles,
        pageSize
    });
    const [page, setPage] = (0, _react.useState)(1);
    const [loading, setLoading] = (0, _react.useState)(false);
    const loadMore = (0, _react.useCallback)(()=>{
        setLoading(true);
        setTimeout(()=>{
            setPage((prevPage)=>prevPage < countOfPages ? prevPage + 1 : prevPage);
            setLoading(false);
        }, _constants.PAGINATION_DELAY);
    }, [
        countOfPages
    ]);
    return {
        articles: articles.slice(0, page * pageSize),
        countOfPages,
        loadingArticles: loading,
        loadMore
    };
};
exports.useGetArticles = useGetArticles;
